import styled from 'styled-components';

export const ProductsContent = styled.section`
  padding: 100px 15px;
`;

export const Logo = styled.img`
  width: 175px;
  margin: 0 auto 30px auto;
  display: block;
`;
